import React, { useEffect, useRef, useState } from 'react';

export function StatPill({
  label,
  value,
  accent = false,
  muted = false,
  title,
}) {
  const prevRef = useRef(null);
  const [fx, setFx] = useState(null);

  useEffect(() => {
    const next = Number(value);
    const prev = prevRef.current;

    if (prev === null || Number.isNaN(next)) {
      prevRef.current = next;
      return undefined;
    }

    if (prev === next) return undefined;

    const delta = next - prev;
    prevRef.current = next;
    if (delta === 0) return undefined;

    setFx({ delta, dir: delta > 0 ? 'up' : 'down' });
    const t = setTimeout(() => setFx(null), 850);
    return () => clearTimeout(t);
  }, [value]);

  return (
    <div
      className={`stat-pill${accent ? ' is-accent' : ''}${
        muted ? ' is-muted' : ''
      }${fx ? ` is-${fx.dir}` : ''}`}
      title={title || undefined}
    >
      <span className="stat-k">{label}</span>
      <span className="stat-v">{value}</span>
      {fx ? (
        <span className={`stat-delta is-${fx.dir}`} aria-hidden="true">
          {fx.delta > 0 ? `+${fx.delta}` : fx.delta}
        </span>
      ) : null}
    </div>
  );
}

export default function QuestionValue({ value, questionNumber, status }) {
  if (status === 'idle') {
    return null;
  }

  const done = status === 'resolved';

  return (
    <StatPill
      label={`#${questionNumber} savol bali`}
      value={value}
      accent={!done}
      muted={done}
      title={done ? 'Raund tugadi' : `Savol #${questionNumber} narxi`}
    />
  );
}
